<div class="form-group">
  <label> Inspection Version: </label>
  <select class="form-control" style="display: inline-block; width: auto; margin-right: 15px" [(ngModel)]="versionName">
    <option *ngFor="let v of versions" [value]="v.name">{{ v.name }} {{ v.tags ? '[' + v.tags + ']' : '' }}</option>
  </select>
</div>

<ng-container *ngFor="let item of items">
  <ng-container *ngFor="let section of item.sections">
    <div style="page-break-after: always; margin-bottom: 40px" *ngFor="let question of section.questions">
      <h6>Item: {{ item.name }}</h6>
      <h6>Section: {{ section.name }}</h6>
      <h5>Question: {{ question.text }}</h5>
      <h6>Legacy ID: {{ question.legacyId }}</h6>
      <h6>Type: {{ question.type }}</h6>

      <div style="border: 1px solid #000; padding: 10px 30px; margin: 30px">
        <ngx-md [data]="prepare(question.helpText)"></ngx-md>
      </div>

      <h6 *ngIf="question.helpPictures?.length">Question Help Images ({{ question.helpPictures.length }})</h6>
      <div *ngFor="let pic of question.helpPictures">
        <div style="max-width: 50%">
          <img-ajax [src]="pic.Location" [queue]="imageQueue"></img-ajax>
        </div>
        <b>Legend:</b>
        <div style="border: 1px solid #000; padding: 10px 30px; margin: 10px">
          {{ pic.caption }}
        </div>
        <hr />
      </div>

      <h6 *ngIf="question.type === 'pick-list'">Question Options ({{ question.options?.length }})</h6>
      <div *ngFor="let opt of question.options">
        <h6>{{ opt.text }}</h6>
        <p>Help:</p>
        <div style="border: 1px solid #000; padding: 10px 30px; margin: 10px">
          {{ opt.helpText || 'NO HELP CONTENT' }}
        </div>

        <div style="padding: 0 50px" *ngIf="opt.helpPictures?.length">
          <h6>
            Option pictures ({{ opt.helpPictures?.length }}) - <small>{{ opt.text }}</small>
          </h6>
          <div *ngFor="let pic of opt.helpPictures">
            <div style="width: 50%">
              <img-ajax [src]="pic.Location" [queue]="imageQueue"></img-ajax>
            </div>

            <b>Legend:</b>
            <div style="border: 1px solid #000; padding: 10px 30px; margin: 10px">
              {{ pic.caption || 'NO LEGEND' }}
            </div>
          </div>
        </div>

        <hr />
      </div>
    </div>
  </ng-container>
</ng-container>
